export default function Services() {
  const services = [
    {
      icon: 'ri-code-box-line',
      title: 'Custom Software Development',
      description: 'Tailored enterprise solutions built with cutting-edge technologies to meet your unique business requirements and scale with your growth.',
      badge: 'Enterprise Ready',
      color: 'from-slate-800 to-slate-900',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20illustration%20of%20custom%20software%20development%20with%20floating%20code%20snippets%20and%20programming%20elements%20on%20dark%20navy%20blue%20gradient%20background%2C%20modern%20tech%20aesthetic%20with%20geometric%20shapes%20and%20glowing%20accents%20in%20teal%20color%2C%20professional%20enterprise%20software%20concept%20with%20abstract%20data%20visualization&width=600&height=800&seq=service-001&orientation=portrait'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications that deliver exceptional user experiences on iOS and Android devices.',
      badge: 'iOS & Android',
      color: 'from-teal-600 to-teal-700',
      image: 'https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20development%20illustration%20with%20smartphone%20mockups%20and%20app%20interface%20elements%20on%20vibrant%20teal%20gradient%20background%2C%20clean%20minimalist%20design%20with%20floating%20UI%20components%20and%20touch%20gestures%2C%20professional%20mobile%20technology%20concept%20with%20simple%20geometric%20patterns&width=600&height=800&seq=service-002&orientation=portrait'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Digital Transformation',
      description: 'Strategic consulting and implementation services to modernize your business processes and accelerate digital innovation.',
      badge: 'Future Ready',
      color: 'from-amber-500 to-orange-600',
      image: 'https://readdy.ai/api/search-image?query=Professional%20digital%20transformation%20concept%20with%20abstract%20technology%20elements%20and%20business%20innovation%20symbols%20on%20warm%20orange%20gradient%20background%2C%20modern%20corporate%20aesthetic%20with%20flowing%20data%20streams%20and%20connectivity%20nodes%2C%20clean%20minimalist%20design%20representing%20business%20evolution&width=600&height=800&seq=service-003&orientation=portrait'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure and migration services leveraging AWS, Azure, and Google Cloud platforms for optimal performance.',
      badge: 'Cloud Native',
      color: 'from-blue-600 to-indigo-700',
      image: 'https://readdy.ai/api/search-image?query=Clean%20cloud%20computing%20illustration%20with%20abstract%20cloud%20infrastructure%20elements%20on%20blue%20gradient%20background%2C%20modern%20tech%20aesthetic%20with%20network%20connections%20and%20server%20nodes%2C%20professional%20enterprise%20cloud%20concept%20with%20minimalist%20geometric%20design%20and%20soft%20lighting&width=600&height=800&seq=service-004&orientation=portrait'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Data Analytics & AI',
      description: 'Advanced analytics solutions and AI-powered tools to unlock insights from your data and drive intelligent decision-making.',
      badge: 'AI Powered',
      color: 'from-purple-600 to-pink-600',
      image: 'https://readdy.ai/api/search-image?query=Modern%20data%20analytics%20and%20artificial%20intelligence%20visualization%20with%20abstract%20charts%20graphs%20and%20neural%20network%20patterns%20on%20purple%20gradient%20background%2C%20clean%20tech%20aesthetic%20with%20glowing%20data%20points%20and%20flowing%20information%20streams%2C%20professional%20AI%20concept%20with%20minimalist%20design&width=600&height=800&seq=service-005&orientation=portrait'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity Services',
      description: 'Comprehensive security solutions to protect your digital assets, ensure compliance, and maintain business continuity.',
      badge: 'Secure',
      color: 'from-red-600 to-rose-700',
      image: 'https://readdy.ai/api/search-image?query=Professional%20cybersecurity%20concept%20with%20shield%20symbols%20and%20digital%20protection%20elements%20on%20red%20gradient%20background%2C%20modern%20security%20aesthetic%20with%20lock%20icons%20and%20encrypted%20data%20visualization%2C%20clean%20minimalist%20design%20representing%20digital%20safety%20and%20network%20protection&width=600&height=800&seq=service-006&orientation=portrait'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-6">
          <div>
            <p className="text-teal-600 font-medium mb-3 text-sm uppercase tracking-wider">Our Expertise</p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Solutions That Drive
              <br />
              <span className="italic">Real Results</span>
            </h2>
          </div>
          <p className="text-gray-600 max-w-xl leading-relaxed">
            We combine technical excellence with business acumen to deliver software solutions that transform operations and accelerate growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className={`relative h-64 bg-gradient-to-br ${service.color} overflow-hidden`}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-full border border-white/30">
                    {service.badge}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed text-sm">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
